import HomeView from '@/pages/Home.vue';
import Login from '@/pages/Login.vue';

/* employees */
import Employees from '@/pages/employees/Employees.vue';
// employee info pages
import Employee from '@/pages/employees/employee/Employee.vue';
import EmployeeInfo from '@/pages/employees/employee/inner-pages/employee-Info/EmployeeInfo.vue';
import PersonalInfo from '@/pages/employees/employee/inner-pages/employee-Info/inner-pages/PersonalInfo.vue';
import AcademicQualifications from '@/pages/employees/employee/inner-pages/employee-Info/inner-pages/AcademicQualifications.vue';
import PracticalExperiences from '@/pages/employees/employee/inner-pages/employee-Info/inner-pages/PracticalExperiences.vue';
import EmployeeAttachments from '@/pages/employees/employee/inner-pages/employee-Info/inner-pages/EmployeeAttachments.vue';
// import WorkAndVacations from '@/pages/employees/employee/inner-pages/WorkAndVacations.vue';
import JobRecords from '@/pages/employees/employee/inner-pages/JobRecords';
import EmployeeSalary from '@/pages/employees/employee/inner-pages/EmployeeSalary';
import EmployeePenaltiesAndRewards from '@/pages/employees/employee/inner-pages/EmployeePenaltiesAndRewards';
import EmployeeInterviews from '@/pages/employees/employee/inner-pages/EmployeeInterviews';

import EmployeeAttendance from '@/pages/employees/employee/inner-pages/attendance/EmployeeAttendance';
import WorkEmployeeAttendance from '@/pages/employees/employee/inner-pages/attendance/inner-pages/WorkEmployeeAttendance';
import VacationEmployeeAttendance from '@/pages/employees/employee/inner-pages/attendance/inner-pages/VacationEmployeeAttendance';
import PermissionEmployeeAttendance from '@/pages/employees/employee/inner-pages/attendance/inner-pages/PermissionEmployeeAttendance';
import MissionEmployeeAttendance from '@/pages/employees/employee/inner-pages/attendance/inner-pages/MissionEmployeeAttendance';

/* Sections */
import Sections from '@/pages/sections/Sections.vue';

/* attendance */
import Attendance from '@/pages/attendance/Attendance.vue';
import WorkAttendance from '@/pages/attendance/inner-pages/WorkAttendance';
import VacationAttendance from '@/pages/attendance/inner-pages/VacationAttendance';
import PermissionAttendance from '@/pages/attendance/inner-pages/PermissionAttendance';
import MissionAttendance from '@/pages/attendance/inner-pages/MissionAttendance';
import FingerprintsDevices from '@/pages/attendance/inner-pages/FingerprintsDevices';

/* salary */
import SalariesDeatials from '@/pages/salaries/SalariesDeatials';
import AddSalaries from '@/pages/salaries/AddSalaries';

/* punishments and rewards */
import PenaltiesAndRewards from '@/pages/penalties-and-rewards/PenaltiesAndRewards';

/* punishments and rewards */
import Trainings from '@/pages/trainings/Trainings';
import Training from '@/pages/trainings/Training';

/* reminders */
import Reminders from '@/pages/reminders/Reminders';

/* Evaluations */
import Evaluations from '@/pages/evaluations/Evaluations'

/* Interviews */
import Interviews from '@/pages/interviews/Interviews';
import AddInterview from '@/pages/interviews/addInterview/AddInterview';
import InterviewRanking from '@/pages/interviews/addInterview/InterviewRanking';
import EmployeePerformance from '@/pages/interviews/addInterview/EmployeePerformance';
import EvaluatePerformanceDuringTheExperiment from '@/pages/interviews/addInterview/EvaluatePerformanceDuringTheExperiment';
import TechnicalPerformance from '@/pages/interviews/addInterview/TechnicalPerformance';
import JobSatisfactionQuestionnaire from '@/pages/interviews/addInterview/JobSatisfactionQuestionnaire';


/* settings */
import Settings from '@/pages/settings/Settings';
import AddAttendanceType from '@/pages/settings/inner-pages/AddAttendanceType';
import AddVacationType from '@/pages/settings/inner-pages/AddVacationType';
import AddPersonalInformation from '@/pages/settings/inner-pages/AddPersonalInformation';
import AddPenaltiesAndRewardsType from '@/pages/settings/inner-pages/AddPenaltiesAndRewardsType';
import AddJobPosition from '@/pages/settings/inner-pages/AddJobPosition';
import AddAllowanceType from '@/pages/settings/inner-pages/AddAllowanceType';
import SalariesSettings from '@/pages/settings/inner-pages/SalariesSettings';
import RemindersTypes from '@/pages/settings/inner-pages/RemindersTypes';
import DefaultTableHeaders from '@/pages/settings/inner-pages/DefaultTableHeaders';
import EmployeesSettings from '@/pages/settings/EmployeesSettings'
import AttendanceSettings from '@/pages/settings/AttendanceSettings'
import AddPermissionsType from '@/pages/settings/inner-pages/AddPermissionsType'
import AddMissionsType from '@/pages/settings/inner-pages/AddMissionsType'
import AddJobPlace from '@/pages/settings/inner-pages/AddJobPlace'
import ManagerSettings from '@/pages/settings/ManagerSettings'
import AddLanguages from '@/pages/settings/inner-pages/AddLanguages'
import AddComputerSkills from '@/pages/settings/inner-pages/AddComputerSkills'
import AddDetailsType from '@/pages/settings/inner-pages/AddDetailsType'
import SettingsUsers from '@/pages/settings/SettingsUsers'
import Leaves from '@/pages/settings/Leaves'

// users
import Users from '@/pages/employees/employee/Users'

import OrderManagement from '@/pages/orders/OrderManagement.vue'
import Covenant from '@/pages/employees/employee/inner-pages/Covenant'
import Complaints from '@/pages/employees/employee/inner-pages/Complaints'
import EmployeeTraining from '@/pages/employees/employee/inner-pages/EmployeeTraining'
import SalaryEmployees from '@/pages/employees/employee/inner-pages/SalaryEmployees'

import Roles from '@/pages/settings/Roles.vue'

// salary
import SalariesTabs from '@/pages/salaries/SalariesTabs';
import SalariesView from '@/pages/salaries/SalariesView'

export default [
	{
		path: '/',
		name: 'home',
		component: HomeView,
		meta: {
			i18nTranslateKey: 'home',
		},
	},
	{
		path: '/login',
		name: 'login',
		component: Login,
		meta: {
			i18nTranslateKey: 'login',
		},
	},
	// employees
	{
		path: '/employees',
		name: 'employees',
		component: Employees,
		meta: {
			i18nTranslateKey: 'employees',
		},
	},
	{
		path: '/employee',
		name: 'employee',
		component: Employee,
		meta: {
			i18nTranslateKey: 'employee',
		},
		children: [
			{
				path: '/employee/employee-info',
				name: 'employee-info',
				redirect: { name: 'personal-info' },
				component: EmployeeInfo,
				children: [
					{
						path: '/employee/employee-info/personal-info',
						name: 'personal-info',
						component: PersonalInfo,
						meta: {
							i18nTranslateKey: 'personal-info',
						},
					},
					{
						path: '/employee/employee-info/academic-qualifications',
						name: 'academic-qualifications',
						component: AcademicQualifications,
						meta: {
							i18nTranslateKey: 'academic-qualifications',
						},
					},
					{
						path: '/employee/employee-info/practical-experiences',
						name: 'practical-experiences',
						component: PracticalExperiences,
						meta: {
							i18nTranslateKey: 'practical-experiences',
						},
					},
					{
						path: '/employee/employee-info/employee-attachments',
						name: 'employee-attachments',
						component: EmployeeAttachments,
						meta: {
							i18nTranslateKey: 'employee-attachments',
						},
					},
				],
				meta: {
					i18nTranslateKey: 'employee-info',
				},
			},
			{
				path: '/employee/attendance',
				name: 'employee-attendance',
				component: EmployeeAttendance,
				redirect: { name: 'employee-work' },
				meta: {
					i18nTranslateKey: 'employee-attendance',
				},
				children: [
					{
						path: '/employee/attendance/work',
						name: 'employee-work',
						component: WorkEmployeeAttendance,
						meta: {
							i18nTranslateKey: 'employee-work',
						},
					},
					{
						path: '/employee/attendance/vacation',
						name: 'employee-vacation',
						component: VacationEmployeeAttendance,
						meta: {
							i18nTranslateKey: 'employee-vacation',
						},
					},
					{
						path: '/employee/attendance/permission',
						name: 'employee-permission',
						component: PermissionEmployeeAttendance,
						meta: {
							i18nTranslateKey: 'employee-permission',
						},
					},
					{
						path: '/employee/attendance/mission',
						name: 'employee-mission',
						component: MissionEmployeeAttendance,
						meta: {
							i18nTranslateKey: 'employee-mission',
						},
					},
				],
			},
			{
				path: '/employee/job-records',
				name: 'job-records',
				component: JobRecords,
				meta: {
					i18nTranslateKey: 'job-records',
				},
			},
			{
				path: '/employee/employee-salary',
				name: 'employee-salary',
				component: EmployeeSalary,
				meta: {
					i18nTranslateKey: 'employee-salary',
				},
			},
			{
				path: '/employee/penalties-and-rewards',
				name: 'employee-penalties-and-rewards',
				component: EmployeePenaltiesAndRewards,
				meta: {
					i18nTranslateKey: 'penalties-and-rewards',
				},
			},
			{
				path: '/employee/interviews',
				name: 'employee-interviews',
				component: EmployeeInterviews,
				meta: {
					i18nTranslateKey: 'interviews',
				},
			},
			{
				path: '/employee/covenant',
				name: 'covenant',
				component: Covenant,
				meta: {
					i18nTranslateKey: 'covenant',
				}
			},
			{
				path: '/employee/complaints',
				name: 'complaints',
				component: Complaints,
				meta: {
					i18nTranslateKey: 'complaints',
				}
			},
			{
				path: '/employee/employee-training',
				name: 'employee-training',
				component: EmployeeTraining,
				meta: {
					i18nTranslateKey: 'employee-training',
				}
			},
			{
				
				path: '/employee/salary-employee',
				name: 'salary-employee',
				component: SalaryEmployees,
				meta: {
					i18nTranslateKey: 'salary-employee',
				}
				
			}
		],
	},

	// Sections
	{
		path: '/sections',
		name: 'sections',
		component: Sections,
		meta: {
			i18nTranslateKey: 'sections',
		},
	},

	// attendance
	{
		path: '/attendance',
		name: 'attendance',
		component: Attendance,
		redirect: { name: 'work-attendance' },
		meta: {
			i18nTranslateKey: 'attendance',
		},
		children: [
			{
				path: '/attendance/work-attendance',
				name: 'work-attendance',
				component: WorkAttendance,
				meta: {
					i18nTranslateKey: 'work-attendance',
				},
			},
			{
				path: '/attendance/vacation-attendance',
				name: 'vacation-attendance',
				component: VacationAttendance,
				meta: {
					i18nTranslateKey: 'vacation-attendance',
				},
			},
			{
				path: '/attendance/permission-attendance',
				name: 'permission-attendance',
				component: PermissionAttendance,
				meta: {
					i18nTranslateKey: 'permission-attendance',
				},
			},
			{
				path: '/attendance/mission-attendance',
				name: 'mission-attendance',
				component: MissionAttendance,
				meta: {
					i18nTranslateKey: 'mission-attendance',
				},
			},
			{
				path: '/attendance/fingerprints-devices',
				name: 'fingerprints-devices',
				component: FingerprintsDevices,
				meta: {
					i18nTranslateKey: 'fingerprints-devices',
				},
			},
		],
	},


	// penalties and rewards
	{
		path: '/penalties-and-rewards',
		name: 'penalties-and-rewards',
		component: PenaltiesAndRewards,
		meta: {
			i18nTranslateKey: 'penalties-and-rewards',
		},
	},

	// trainings
	{
		path: '/trainings',
		name: 'trainings',
		component: Trainings,
		meta: {
			i18nTranslateKey: 'trainings',
		},
	},
	{
		path: '/training/:id?',
		name: 'training',
		component: Training,
		meta: {
			i18nTranslateKey: 'training',
		},
	},

	// Reminders
	{
		path: '/reminders',
		name: 'reminders',
		component: Reminders,
		meta: {
			i18nTranslateKey: 'reminders',
		},
	},

	{
		path: '/evaluations',
		name: 'evaluations',
		component: Evaluations,
		meta: {
			i18nTranslateKey: 'evaluations',
		}
	},

	// interviews
	{
		path: '/interviews',
		name: 'interviews',
		component: Interviews,
		meta: {
			i18nTranslateKey: 'interviews',
		},
	},
	// add interviews
	{
		path: '/add-interview',
		name: 'add-interview',
		component: AddInterview,
		meta: {
			i18nTranslateKey: 'add-interview',
		},
		redirect: { name: 'interview-ranking' },
		children: [
			{
				path: '/add-interview/interview-ranking',
				name: 'interview-ranking',
				component: InterviewRanking,
				meta: {
					i18nTranslateKey: 'interview-ranking',
				},
			},
			{
				path: '/add-interview/employee-performance',
				name: 'employee-performance',
				component: EmployeePerformance,
				meta: {
					i18nTranslateKey: 'employee-performance',
				},
			},
			{
				path: '/add-interview/evaluate-performance-during-the-experiment',
				name: 'evaluate-performance-during-the-experiment',
				component: EvaluatePerformanceDuringTheExperiment,
				meta: {
					i18nTranslateKey: 'evaluate-performance-during-the-experiment',
				},
			},
			{
				path: '/add-interview/technical-performance',
				name: 'technical-performance',
				component: TechnicalPerformance,
				meta: {
					i18nTranslateKey: 'technical-performance',
				},
			},

			{
				path: '/add-interview/job-satisfaction-questionnaire',
				name: 'job-satisfaction-questionnaire',
				component: JobSatisfactionQuestionnaire,
				meta: {
					i18nTranslateKey: 'job-satisfaction-questionnaire',
				},
			}

			
		],
	},

	// settings
	{
		path: '/settings',
		name: 'settings',
		component: Settings,
		redirect: { name: 'add-attendance-type' },
		meta: {
			i18nTranslateKey: 'settings',
		},
		children: [
			{
				path: '/settings/employees-settings',
				name: 'employees-settings',
				component: EmployeesSettings,
				meta: {
					i18nTranslateKey: 'employees-settings'
				},
				children: [
					{
						path: '/settings/add-vacation-type',
						name: 'add-vacation-type',
						component: AddVacationType,
						meta: {
							i18nTranslateKey: 'add-vacation-type',
						},
					},

					{
						path: '/settings/add-penalties-and-rewards-type',
						name: 'add-penalties-and-rewards-type',
						component: AddPenaltiesAndRewardsType,
						meta: {
							i18nTranslateKey: 'add-penalties-and-rewards-type',
						},
					},

					{
						path: '/settings/add-permissions-type',
						name: 'add-permissions-type',
						component: AddPermissionsType,
						meta: {
							i18nTranslateKey: 'add-permissions-type',
						},
					},

					{
						path: '/settings/add-missions-type',
						name: 'add-missions-type',
						component: AddMissionsType,
						meta: {
							i18nTranslateKey: 'add-missions-type',
						},
						
					}
				]
			},
			{
				path: '/settings/attendance-settings',
				name: 'attendance-settings',
				component: AttendanceSettings,
				meta: {
					i18nTranslateKey: 'attendance-settings'
				},
				children: [
					{
						path: '/settings/add-attendance-type',
						name: 'add-attendance-type',
						component: AddAttendanceType,
						meta: {
							i18nTranslateKey: 'add-attendance-type',
						},
					},
					{
						path: '/settings/add-job-place',
						name: 'add-job-place',
						component: AddJobPlace,
						meta: {
							i18nTranslateKey: 'add-job-place',
						},
					}
				]
			},
			{
				path: '/settings/manager-settings',
				name: 'manager-settings',
				component: ManagerSettings,
				meta: {
					i18nTranslateKey: 'manager-settings',
				},
				children: [
					{
						path: '/settings/add-job-position',
						name: 'add-job-position',
						component: AddJobPosition,
						meta: {
							i18nTranslateKey: 'add-job-position',
						},
					},
					{
						path: '/settings/add-languages',
						name: 'add-languages',
						component: AddLanguages,
						meta: {
							i18nTranslateKey: 'add-languages',
						},
					},
					{
						path: '/settings/add-computer-skills',
						name: 'add-computer-skills',
						component: AddComputerSkills,
						meta: {
							i18nTranslateKey: 'add-computer-skills',
						}
					},
					{
						path: '/settings/add-details-type',
						name: 'add-details-type',
						component: AddDetailsType,
						meta: {
							i18nTranslateKey: 'add-details-type',
						}
						
					}
				]
			},
			{
				path: '/settings/add-personal-information',
				name: 'add-personal-information',
				component: AddPersonalInformation,
				meta: {
					i18nTranslateKey: 'add-personal-information',
				},
			},
			{
				path: '/settings/add-allowance-type',
				name: 'add-allowance-type',
				component: AddAllowanceType,
				meta: {
					i18nTranslateKey: 'add-allowance-type',
				},
			},
			{
				path: '/settings/salaries',
				name: 'salaries-settings',
				component: SalariesSettings,
				meta: {
					i18nTranslateKey: 'salaries',
				},
			},
			{
				path: '/settings/reminders-types',
				name: 'reminders-types',
				component: RemindersTypes,
				meta: {
					i18nTranslateKey: 'reminders-types',
				},
			},
			{
				path: '/settings/default-table-headers',
				name: 'default-table-headers',
				component: DefaultTableHeaders,
				meta: {
					i18nTranslateKey: 'default-table-headers',
				},
			},
			

			{
				path: '/settings-users',
				name: 'settings-users',
				component: SettingsUsers,
				meta: {
					i18nTranslateKey: 'users',
				},
				children: [
					{
						path: '/users',
						name: 'users',
						component: Users,
						meta: {
							i18nTranslateKey: 'users',
						},
					},
					{
						path: '/roles',
						name: 'roles',
						component: Roles,
						meta: {
							i18nTranslateKey: 'roles',
						}
					}
				]
			},
			{
				path: '/holiday',
				name: 'Leaves',
				component: Leaves,
				meta: {
					i18nTranslateKey: 'holiday'
				}
			}
		]
	},

	{
		path: '/order-management',
		name: 'order-management',
		component: OrderManagement,
		meta: {
			i18nTranslateKey: 'order-management',
		}
	},
	// salary
	{
		path: '/add-salaries',
		name: 'add-salaries',
		component: AddSalaries,
		meta: {
			i18nTranslateKey: 'add-salaries',
		},
	},
	{
		path: '/salaries',
		name: 'salaries-tabs',
		component: SalariesTabs,
		meta: {
			i18nTranslateKey: 'salaries-tabs'
		},
		children: [
			{
				path: '/salaries-details',
				name: 'salaries',
				component: SalariesDeatials,
				meta: {
					i18nTranslateKey: 'salaries',
				},
			},
			{
				path: '/salaries-view',
				name: 'salaries-view',
				component: SalariesView,
				meta: {
					i18nTranslateKey: 'salaries-view',
				}
			}
		]
	}
];
